import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import LeadershipSection from './components/LeadershipSection';
import ValuesSection from './components/ValuesSection';
import BlogSection from './components/BlogSection';
import OfficeSection from './components/OfficeSection';
import CTASection from './components/CTASection';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const logos = [
    { src: "assets/industry/1 (2).png", alt: "Cloud Credentials" },
    { src: "assets/industry/1 (3).png", alt: "WSI Partners" },
    { src: "assets/industry/1 (4).png", alt: "AWS Partner Network" },
    { src: "assets/industry/1 (5).png", alt: "Google Cloud Premier Partner" },
    { src: "assets/industry/1 (6).png", alt: "AWS Partner Slalom" },
    { src: "assets/industry/1 (7).png", alt: "Microsoft Partner Capgemini" },
    { src: "assets/industry/1 (8).png", alt: "AWS Generative AI Competency" },
    { src: "assets/industry/1 (9).png", alt: "Microsoft Azure Partner" },
    { src: "assets/industry/1 (10).png", alt: "Microsoft Qualified Delivery Partner" },
    { src: "assets/industry/1 (11).png", alt: "AWS Premier Tier" },
    { src: "assets/industry/1 (12).png", alt: "Microsoft Data AI TSP" },
    { src: "assets/industry/1 (13).png", alt: "AWS Partner Nordcloud" },
    { src: "assets/industry/1 (14).png", alt: "AWS Partner Network Level Up" },
    { src: "assets/industry/1 (15).png", alt: "AWS Blended Learning Award" },
    { src: "assets/industry/1 (16).png", alt: "AWS Partner Improving" },
    { src: "assets/industry/1 (17).png", alt: "Microsoft Security Partner" },
    { src: "assets/industry/1 (18).png", alt: "Microsoft Gold Partner" },
    { src: "assets/industry/1 (19).png", alt: "Microsoft Global Partner of the Year" },
    { src: "assets/industry/1 (20).png", alt: "AWS Partner BIO-key" },
    { src: "assets/industry/1 (21).png", alt: "AWS Premier Tier Silicon Overdrive" },
    { src: "assets/industry/1 (22).png", alt: "Media Partners Logos" },
    { src: "assets/industry/1 (23).png", alt: "Logo Jungle Example" },
    { src: "assets/industry/1 (24).png", alt: "Money20/20 Media Logos" },
    { src: "assets/industry/1 (25).png", alt: "Media & Entertainment Symposium Logos" },
    { src: "assets/industry/1 (26).png", alt: "CNBC Corporate Marketing" },
    { src: "assets/industry/1 (27).png", alt: "Forbes Creator Upfronts" },
    { src: "assets/industry/1 (28).png", alt: "CNBC Changemakers" },
    { src: "assets/industry/1 (29).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (30).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (31).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (32).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (33).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (34).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (35).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (36).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (37).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (38).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (39).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (40).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (41).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (42).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (43).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1 (44).png", alt: "Featured in Financial Media" },
    { src: "assets/industry/1.png", alt: "Featured in Financial Media" },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <StorySection />
        <LeadershipSection />
        <ValuesSection />

        {/* Industry Recognition & Media Trust */}
        <section className="py-16 md:py-24 bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-white overflow-hidden">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Industry Recognition & Media Trust
            </h2>
            <p className="text-lg md:text-xl max-w-4xl mx-auto mb-16">
              Our affiliations, certifications, and media partnerships highlight our capability to deliver enterprise-grade solutions.
            </p>

            <div className="relative h-80 md:h-[28rem] overflow-hidden">
              {/* Top Row */}
              <div className="flex absolute top-0 left-0">
                <div className="flex animate-marquee-slow">
                  {logos.map((logo, index) => (
                    <div
                      key={`top-${index}`}
                      className="
                        flex-shrink-0
                        w-80 h-80
                        md:w-[26rem] md:h-[26rem]
                        flex items-center justify-center
                        p-8
                        mx-3
                        transition-all duration-500
                        hover:scale-110 hover:-translate-y-10 hover:z-10
                      "
                    >
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  ))}
                </div>

                <div className="flex animate-marquee-slow">
                  {logos.map((logo, index) => (
                    <div
                      key={`top-dup-${index}`}
                      className="
                        flex-shrink-0
                        w-80 h-80
                        md:w-[26rem] md:h-[26rem]
                        flex items-center justify-center
                        p-8
                        mx-3
                        transition-all duration-500
                        hover:scale-110 hover:-translate-y-10 hover:z-10
                      "
                    >
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Bottom Row */}
              <div className="flex absolute bottom-0 left-0">
                <div className="flex animate-marquee-slow-reverse">
                  {logos.slice().reverse().map((logo, index) => (
                    <div
                      key={`bottom-${index}`}
                      className="
                        flex-shrink-0
                        w-80 h-80
                        md:w-[26rem] md:h-[26rem]
                        flex items-center justify-center
                        p-8
                        mx-3
                        transition-all duration-500
                        hover:scale-110 hover:translate-y-10 hover:z-10
                      "
                    >
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  ))}
                </div>

                <div className="flex animate-marquee-slow-reverse">
                  {logos.slice().reverse().map((logo, index) => (
                    <div
                      key={`bottom-dup-${index}`}
                      className="
                        flex-shrink-0
                        w-80 h-80
                        md:w-[26rem] md:h-[26rem]
                        flex items-center justify-center
                        p-8
                        mx-3
                        transition-all duration-500
                        hover:scale-110 hover:translate-y-10 hover:z-10
                      "
                    >
                      <img
                        src={logo.src}
                        alt={logo.alt}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <style jsx>{`
            @keyframes marquee-slow {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            @keyframes marquee-slow-reverse {
              0% { transform: translateX(-50%); }
              100% { transform: translateX(0); }
            }
            .animate-marquee-slow {
              animation: marquee-slow 60s linear infinite;
            }
            .animate-marquee-slow-reverse {
              animation: marquee-slow-reverse 65s linear infinite;
            }
            .animate-marquee-slow:hover,
            .animate-marquee-slow-reverse:hover {
              animation-play-state: paused;
            }
          `}</style>
        </section>

        <BlogSection />

        <OfficeSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default About;
